import { render, staticRenderFns } from "./EmailOTP.vue?vue&type=template&id=f4055336&"
import script from "./EmailOTP.vue?vue&type=script&lang=js&"
export * from "./EmailOTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports